
        
const main = async(UX) => {
    const $utm = document.querySelector('body'),
        $resizeImages = Array.prototype.slice.call(document.querySelectorAll('body')),
        $fancybox = Array.prototype.slice.call(document.getElementsByClassName('abstract-preview__visual')),
        $copyText = Array.prototype.slice.call(document.getElementsByClassName('copy__btn')),
        $toggleTable = Array.prototype.slice.call(document.querySelectorAll('.expandable, table')),
        $institutionSearch = Array.prototype.slice.call(document.getElementsByClassName('institution-search')),
        $datepicker = Array.prototype.slice.call(document.getElementsByClassName('datepicker')),
        $progressBar = Array.prototype.slice.call(document.getElementsByClassName('progress-bar')),
        $sidebarSections = Array.prototype.slice.call(document.getElementsByClassName('sections-block')),
        $fileUploader = Array.prototype.slice.call(document.getElementsByClassName('ajax-uploader')),
        $dashboardToolbar = Array.prototype.slice.call(document.getElementsByClassName('dashboard-toolbar')),
        $topContent = Array.prototype.slice.call(document.getElementsByClassName('top-content')),
        $slotLicense = Array.prototype.slice.call(document.getElementsByClassName('slot-license-usage')),
        $slotLicenseConsumption = Array.prototype.slice.call(document.getElementsByClassName('slotLicenseConsumption')),
        $sciteMetrics = Array.prototype.slice.call(document.getElementsByClassName('scite-metrics')),
        $adobeDigitalData = Array.prototype.slice.call(document.querySelectorAll('body')),
        $recommendToLibrarian = Array.prototype.slice.call(document.getElementsByClassName('recommendationForm')),
        $readCubeShare = Array.prototype.slice.call(document.getElementsByClassName('readCube-sharing')),
        $mrw = Array.prototype.slice.call(document.getElementsByClassName('mrw-toc-meta__info')),
        $menu = Array.prototype.slice.call(document.querySelectorAll('[data-toggle="nav"], .hubpage-menu')),
        $institutionDetails = Array.prototype.slice.call(document.getElementsByClassName('institutionDetails')),
        $institutionBanner = Array.prototype.slice.call(document.getElementsByClassName('institution-info-wrapper')),
        $healthcareDisclaimer = Array.prototype.slice.call(document.getElementsByClassName('healthcare-disclaimer-alert')),
        $confirmationDialog = document.getElementById('cancel-dialog'),
        $loadAbst = Array.prototype.slice.call(document.getElementsByClassName('bookSeries')),
        $bulkDownload = Array.prototype.slice.call(document.querySelectorAll('body')),
        $alertSignUpSection = Array.prototype.slice.call(document.getElementsByClassName('alert-sign-up')),
        $loi = Array.prototype.slice.call(document.getElementsByClassName('loi')),
        $publicationVersion = document.querySelector('.issue-item'),
        $keveladplaceholder = Array.prototype.slice.call(document.getElementsByClassName('kevel-ad-placeholder')),
        $loiAccordion = Array.prototype.slice.call(document.getElementsByClassName('loi-accordion')),
        $downloadCitations = Array.prototype.slice.call(document.querySelectorAll('form#refworks')),
        $personalInformation = Array.prototype.slice.call(document.getElementsByClassName('personal-information')),
        $favorites = Array.prototype.slice.call(document.getElementsByClassName('favoriteShortlist')),
        $examCertificate = Array.prototype.slice.call(document.getElementsByClassName('exam-certificate-message')),
        $exportCitation = Array.prototype.slice.call(document.querySelectorAll('#citation-format, .articles-toolbar')),
        $disableADBlocker = Array.prototype.slice.call(document.getElementsByClassName('disable-adblocker__continue-btn')),
        $citedBy = Array.prototype.slice.call(document.querySelectorAll('.cited-by__list, .cited-by')),
        $tfa = Array.prototype.slice.call(document.getElementsByClassName('two-factor-authentication')),
        $showRecommended = Array.prototype.slice.call(document.getElementsByClassName('show-recommended-placeholder')),
        $headerAlt = Array.prototype.slice.call(document.querySelectorAll('body')),
        $eventPage = Array.prototype.slice.call(document.getElementsByClassName('event__content')),
        $truncate = document.querySelector('.js--truncate,.creative-work__title,.loa,.meta__authors, .js--truncate, .loa, .meta__authors'),
        $slideshow = document.querySelector('.slideshow, .slideShow, .owl-carousel, .js-showcase-slideshow'),
        $binders = document.querySelector('.binder-list, .binder__issues'),
        $profile = document.querySelector('.kbart-token_table, .institutionList, .profile-menu, .institutional-affiliations, .renew_verification_message, .admin-manage-alerts, .js__removeAdmins, .trusted-proxy-form, #institutionUsageReport, .usageReports, .js__removeUsers, .alerts, #institutionUsageReport, .device-pairing__devices, #pairingManagmentWidgetId, #holdingsForm, .holdingContainer'),
        $search = document.querySelector('.facet, #dateFacet .range-slider, .facetDateChart, .refineSearch,.advanced-search, .advanced-search, .search-result'),
        $article = document.querySelector('.article-page figure:not(.holder), figure,.article-page .figure:not(.holder),.article-page .colored-block,.article-page .component-container, article, .article-tools__ctrl, .article-page > article'),
        $pd = document.querySelector('.js-editable, .js-counter, .sortable-table, .client-pagination, .autosave-form, .pd-pdf, .pd-action-bar, .submission-authors, .basic-metadata, .funders, .draftForm, .taxonomies-input-group, .submission-list, .supplemental-files, .supplemental-links, .author-index, .authorsHistoryWidget, .advisorActionRecords, .scp')
let promiseVariable = {};
try {
        if ($utm) { 
            promiseVariable.utmPromise = await import (
    /* webpackChunkName: "utm" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/plugins/utm/js/utm'
)

const { default: UTM } = await promiseVariable.utmPromise
UX.utm = new UTM($utm)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($resizeImages.length) { 
            promiseVariable.resizeImagesPromise = await import (
    /* webpackChunkName: "resizeImages" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/plugins/resizeImages/js/resizeImages'
)

        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($fancybox.length) { 
            promiseVariable.fancyboxPromise = await import (
    /* webpackChunkName: "fancybox" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/plugins/fancybox/js/fancybox'
)

        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($copyText.length) { 
            promiseVariable.copyTextPromise = await import (
    /* webpackChunkName: "copyText" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/plugins/copy-text/js/copy-text'
)


UX.copyText.init($copyText);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($toggleTable.length) { 
            promiseVariable.toggleTablePromise = await import (
    /* webpackChunkName: "toggleTable" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/components/tables/js/tables'
)


UX.toggleTable.init($toggleTable);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($institutionSearch.length) { 
            promiseVariable.institutionSearchPromise = await import (
    /* webpackChunkName: "institutionSearch" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/components/institution-search/js/institution-search'
)


UX.institutionSearch.init($institutionSearch);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($datepicker.length) { 
            promiseVariable.datepickerPromise = await import (
    /* webpackChunkName: "datepicker" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/components/datepicker/js/datepicker'
)


UX.datepicker.init($datepicker);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($progressBar.length) { 
            promiseVariable.progressBarPromise = await import (
    /* webpackChunkName: "progressBar" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/components/progress-bar/js/progress-bar'
)


UX.progressBar.init($progressBar);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($sidebarSections.length) { 
            promiseVariable.sidebarSectionsPromise = await import (
    /* webpackChunkName: "sidebarSections" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/components/side-bar-sections/js/side-bar-sections'
)


UX.sidebarSections.init($sidebarSections);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($fileUploader.length) { 
            promiseVariable.fileUploaderPromise = await import (
    /* webpackChunkName: "fileUploader" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/components/file-uploader/js/file-uploader'
)


UX.fileUploader.init($fileUploader);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($dashboardToolbar.length) { 
            promiseVariable.dashboardToolbarPromise = await import (
    /* webpackChunkName: "dashboardToolbar" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/components/dashboard-toolbar/js/dashboard-toolbar'
)

        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($topContent.length) { 
            promiseVariable.topContentPromise = await import (
    /* webpackChunkName: "topContent" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/top-content/js/top-content'
)


UX.topContent.init($topContent);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($slotLicense.length) { 
            promiseVariable.slotLicensePromise = await import (
    /* webpackChunkName: "slotLicense" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/slot-license-usage/js/slot-license-usage'
)


UX.slotLicense.init($slotLicense);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($slotLicenseConsumption.length) { 
            promiseVariable.slotLicenseConsumptionPromise = await import (
    /* webpackChunkName: "slot-license-consumption" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/slot-license-consumption/js/slot-license-consumption'
)

        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($sciteMetrics.length) { 
            promiseVariable.sciteMetricsPromise = await import (
    /* webpackChunkName: "sciteMetrics" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/scite-metrics/js/scite-metrics'
)

const { default: SciteMetrics } = await promiseVariable.sciteMetricsPromise
UX.sciteMetrics = new SciteMetrics($sciteMetrics)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($adobeDigitalData.length) { 
            promiseVariable.adobeDigitalDataPromise = await import (
    /* webpackChunkName: "adobeDigitalData" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/adobe-digitalData/js/adobe-digitalData'
)

const { default: AdobeDigitalData } = await promiseVariable.adobeDigitalDataPromise
UX.adobeDigitalData = new AdobeDigitalData($adobeDigitalData)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($recommendToLibrarian.length) { 
            promiseVariable.recommendToLibrarianPromise = await import (
    /* webpackChunkName: "recommendToLibrarian" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/recommend-to-librarian/js/recommend-to-librarian'
)

        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($readCubeShare.length) { 
            promiseVariable.readCubeSharePromise = await import (
    /* webpackChunkName: "readCubeShare" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/readCube-pTop-sharing/js/readCube-pTop-sharing'
)


UX.readCubeShare.init($readCubeShare);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($mrw.length) { 
            promiseVariable.mrwPromise = await import (
    /* webpackChunkName: "mrw" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/mrw-toc/js/mrw-toc'
)

const { default: MRW } = await promiseVariable.mrwPromise
UX.mrw = new MRW($mrw).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($menu.length) { 
            promiseVariable.menuPromise = await import (
    /* webpackChunkName: "menu" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/menu/js/menu'
)


UX.menu.init($menu);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($institutionDetails.length) { 
            promiseVariable.institutionDetailsPromise = await import (
    /* webpackChunkName: "institutionDetails" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/institution-details/js/institution-details'
)


UX.institutionDetails.init($institutionDetails);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($institutionBanner.length) { 
            promiseVariable.institutionBannerPromise = await import (
    /* webpackChunkName: "institutionBanner" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/institution-banner/js/institution-banner'
)

        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($healthcareDisclaimer.length) { 
            promiseVariable.healthcareDisclaimerPromise = await import (
    /* webpackChunkName: "healthcareDisclaimer" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/healthcare-disclaimer/js/healthcare-disclaimer'
)


UX.healthcareDisclaimer.init($healthcareDisclaimer);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($confirmationDialog) { 
            promiseVariable.confirmationDialogPromise = await import (
    /* webpackChunkName: "confirmationDialog" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/confirmation-dialog/js/confirmation-dialog'
)

        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($loadAbst.length) { 
            promiseVariable.loadAbstPromise = await import (
    /* webpackChunkName: "loadAbst" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/book-series/js/book-series'
)


UX.loadAbst.init($loadAbst);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($bulkDownload.length) { 
            promiseVariable.bulkDownloadPromise = await import (
    /* webpackChunkName: "bulkDownload" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/bulk-download/js/bulk-download'
)

const { default: BulkDownload } = await promiseVariable.bulkDownloadPromise
UX.bulkDownload = new BulkDownload($bulkDownload)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($alertSignUpSection.length) { 
            promiseVariable.alertSignUpSectionPromise = await import (
    /* webpackChunkName: "alertSignUpSection" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/alert-sign-up/js/alert-sign-up'
)

const { default: AlertSignUp } = await promiseVariable.alertSignUpSectionPromise
UX.alertSignUpSection = new AlertSignUp($alertSignUpSection)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($loi.length) { 
            promiseVariable.loiPromise = await import (
    /* webpackChunkName: "loi" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/list-of-issues-links/js/loi'
)


UX.loi.init($loi);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($publicationVersion) { 
            promiseVariable.publicationVersionPromise = await import (
    /* webpackChunkName: "publicationVersion" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/publication-versions/js/publication-versions'
)

const { default: PublicationVersion } = await promiseVariable.publicationVersionPromise
UX.publicationVersion = new PublicationVersion($publicationVersion)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($keveladplaceholder.length) { 
            promiseVariable.keveladplaceholderPromise = await import (
    /* webpackChunkName: "keveladplaceholder" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/kevel-ad-placeholder/js/kevel-ad-placeholder'
)

const { default: kevelAdPlaceholder } = await promiseVariable.keveladplaceholderPromise
UX.keveladplaceholder = new kevelAdPlaceholder($keveladplaceholder)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($loiAccordion.length) { 
            promiseVariable.loiAccordionPromise = await import (
    /* webpackChunkName: "loiAccordion" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/widgets/list-of-issues-detailed/js/list-of-issues-accordion'
)

        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($downloadCitations.length) { 
            promiseVariable.downloadCitationsPromise = await import (
    /* webpackChunkName: "downloadCitations" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/download-citations/js/download-citations'
)

        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($personalInformation.length) { 
            promiseVariable.personalInformationPromise = await import (
    /* webpackChunkName: "personalInformation" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/personal-information/js/personal-information'
)


UX.personalInformation.init($personalInformation);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($favorites.length) { 
            promiseVariable.favoritesPromise = await import (
    /* webpackChunkName: "favorites" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/favorites/js/favorites'
)


UX.favorites.init($favorites);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($examCertificate.length) { 
            promiseVariable.examCertificatePromise = await import (
    /* webpackChunkName: "examCertificate" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/widgets/exam-certificate/js/exam-certificate'
)

        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($exportCitation) { 
            promiseVariable.exportCitationPromise = await import (
    /* webpackChunkName: "exportCitation" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/export-citations/js/export-citations'
)


UX.exportCitation.init($exportCitation);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($disableADBlocker.length) { 
            promiseVariable.disableADBlockerPromise = await import (
    /* webpackChunkName: "disableADBlocker" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/widgets/disable-adblocker/js/disable-adblocker'
)


UX.disableADBlocker.init($disableADBlocker);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($citedBy.length) { 
            promiseVariable.citedByPromise = await import (
    /* webpackChunkName: "citedBy" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/cited-by/js/cited-by'
)


UX.citedBy.init($citedBy);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($tfa.length) { 
            promiseVariable.tfaPromise = await import (
    /* webpackChunkName: "tfa" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/widgets/two-factor-authentication/js/two-factor-authentication'
)


UX.tfa.init($tfa);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($headerAlt.length) { 
            promiseVariable.headerAltPromise = await import (
    /* webpackChunkName: "headerAlt" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/templates/header/js/header-alt'
)

        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($eventPage.length) { 
            promiseVariable.eventPagePromise = await import (
    /* webpackChunkName: "eventPage" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/templates/event-page/js/event-page'
)


UX.eventPage.init($eventPage);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($truncate) { 
            promiseVariable.truncatePromise = await import (
    /* webpackChunkName: "truncate" */ 
    './groups/_truncate'
)

const { default: truncateMain } = await promiseVariable.truncatePromise
truncateMain(UX)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($slideshow) { 
            promiseVariable.slideshowPromise = await import (
    /* webpackChunkName: "slideshow" */ 
    './groups/_slideshow'
)

const { default: slideshowMain } = await promiseVariable.slideshowPromise
slideshowMain(UX)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($binders) { 
            promiseVariable.bindersPromise = await import (
    /* webpackChunkName: "binders" */ 
    './groups/_binders'
)

        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($profile) { 
            promiseVariable.profilePromise = await import (
    /* webpackChunkName: "profile" */ 
    './groups/_profile'
)

const { default: profileMain } = await promiseVariable.profilePromise
profileMain(UX)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($pd) { 
            promiseVariable.pdPromise = await (async () => {
    await Promise.all([promiseVariable.truncatePromise].filter(promise => !!promise));
    return await import (
    /* webpackChunkName: "pd" */ 
    './groups/_pd'
)
;
})();
const { default: pdMain } = await promiseVariable.pdPromise
pdMain(UX)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($article) { 
            promiseVariable.articlePromise = await (async () => {
    await Promise.all([promiseVariable.truncatePromise].filter(promise => !!promise));
    return await import (
    /* webpackChunkName: "article" */ 
    './groups/_article'
)
;
})();
const { default: articleMain } = await promiseVariable.articlePromise
articleMain(UX)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($search) { 
            promiseVariable.searchPromise = await (async () => {
    await Promise.all([promiseVariable.truncatePromise].filter(promise => !!promise));
    return await import (
    /* webpackChunkName: "search" */ 
    './groups/_search'
)
;
})();
const { default: searchMain } = await promiseVariable.searchPromise
searchMain(UX)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($showRecommended.length) { 
            promiseVariable.showRecommendedPromise = await (async () => {
    await Promise.all([promiseVariable.truncatePromise].filter(promise => !!promise));
    return await import (
    /* webpackChunkName: "showRecommended" */ 
    '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/widgets/show-recommended/js/show-recommended'
)
;
})();

UX.showRecommended.init($showRecommended);
        }
    } catch (err) {
        console.error(err);
    }
    
return promiseVariable
}


        export default main;
        